module.exports = __webpack_public_path__ + "src/assets/textures/env/wagon/wagon_2k_bake.png";